export default "__VITE_ASSET__CITDXKYy__"